export default {
  auth: true,
  slug: 'notification',
}
